<template>
  <div>
    <div class="playground-error text-danger" v-if="error">
      <div class="text-danger" v-if="tries > 0">Oops... Try one more time (already {{tries}} times)!</div>
      <div class="text-danger" v-else>Oops... Try one more time!</div>
    </div>

    <div id="playground-editors"></div>

    <div class="center-obj">
      <button v-on:click="completeTask" class="btn btn-blue">Complete</button>
    </div>
  </div>
</template>

<script>
    import CodeMirrorHelper from "../../utils/codemirror"

    import {
        TASK_PLAYGROUND_REQUEST,
        VALIDATE_USER_ANSWER,
        GET_TASK,
        UPDATE_USER_TASK,
    } from "../../store/actions/task";

    export default {
        name: "WorkflowArea",
        props: ["taskId", "mode"],
        data() {
            return {
                task: null,
                taskPlayground: null,
                error: null,
                tries: 0,
                editCodeAreas: [],
            };
        },
        created() {
            this.$store.dispatch(GET_TASK, this.taskId).then(task => {
                this.task = task;
            });
            this.$store.dispatch(TASK_PLAYGROUND_REQUEST, this.taskId).then(taskPlayground => {
                this.taskPlayground = taskPlayground;
                this.initCodeEditors();
            });

            if (this.$store.getters.getCurrentUserTask)
                this.tries = this.$store.getters.getCurrentUserTask.tries
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getCurrentUserTask,
                (userTask) => {
                    this.tries = userTask.tries;
                },
            );
        },
        methods: {
            initCodeEditors() {
                this.taskPlayground.playgrounds.forEach(playground => {
                    let editorElement = document.createElement('div');
                    editorElement.classList.add('playground-code-editor');
                    editorElement.id = `codeWorkAreaEditor${playground.mode}`;

                    document.getElementById('playground-editors').append(editorElement);

                    this.initWorkAreaCodeMirror(editorElement, playground.mode, playground.code);
                });
            },
            initWorkAreaCodeMirror(editorElement, mode, code) {
                if(mode === 'html') mode = 'htmlmixed';

                let codeEditor = CodeMirrorHelper.initCodeMirrorArea(editorElement, mode, code, false);
                codeEditor.on('change', () => {
                    this.error = false;
                });

                this.editCodeAreas.push(codeEditor);
            },
            completeTask() {
                this.error = false;

                let userResults = [];

                this.editCodeAreas.forEach(editor => {
                    let mode = editor.getMode().name;
                    if (mode === 'htmlmixed') mode = 'html';

                    userResults.push({
                        mode: mode,
                        code: editor.getValue()
                    })
                });

                this.$store
                    .dispatch(VALIDATE_USER_ANSWER, {
                        taskPlayground: this.taskPlayground,
                        userTask: this.$store.getters.getCurrentUserTask,
                        userResults: userResults,
                        maxPoints: this.task.maxPoints,
                        currentPoints: this.$store.getters.getCurrentUserData.rate,
                    })
                    .then(res => {
                        this.$store.dispatch(UPDATE_USER_TASK, res);

                        this.$router.push({
                            name: "TaskResult",
                            params: {
                                id: this.taskId,
                                courseId: this.task.courseId,
                                points: res.gotPoints,
                            },
                        });
                    })
                    .catch(err => {
                        let error = JSON.parse(err.message);

                        if (!error.userTask.endedDate) {
                            this.$store.dispatch(UPDATE_USER_TASK, error.userTask);
                            this.tries = error.userTask.tries;
                        } else {
                            this.tries = 0;
                        }

                        this.error = true;

                        error.userErrors.forEach(workAreaError => {
                            this.animateErrorPlayground(this.editCodeAreas.find(x => {
                                if (workAreaError.mode === 'html') return x.getMode().name === 'htmlmixed';
                                return x.getMode().name === workAreaError.mode
                            }).display.wrapper);
                        })
                    });
            },
            animateErrorPlayground(container) {
                container.classList.remove('CodeMirror-failed');

                setTimeout(() => container.classList.add('CodeMirror-failed'), 100);
            }
        },
    };
</script>

<style scoped>
  .playground-error {
    margin: 1.5rem 1.5rem 0.5rem;
  }
</style>
